import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withGenericConfig } from "contexts/generic-config-context";
import { StyledStructuredHeaderMenuBottomPartComponent } from "./structured-header-menu-bottom-part.scss";
import SocialProofComponent from "./structured-header-menu-bottom-part-components/social-proof-component";
import BottomItemsComponent from "./structured-header-menu-bottom-part-components/bottom-items-component";
const StructuredHeaderMenuBottomPartComponent = (props)=>{
    const { menuId, panel } = props;
    const { bottomItems: items, isSocialProofDisplayed } = panel;
    return /*#__PURE__*/ _jsxs(StyledStructuredHeaderMenuBottomPartComponent, {
        className: "structured-header-menu-bottom-part-component",
        children: [
            isSocialProofDisplayed && /*#__PURE__*/ _jsx(SocialProofComponent, {}),
            /*#__PURE__*/ _jsx("div", {
                className: "spacer"
            }),
            items && /*#__PURE__*/ _jsx(BottomItemsComponent, {
                menuId: menuId,
                items: items
            })
        ]
    });
};
export default withGenericConfig(StructuredHeaderMenuBottomPartComponent);
